import { render, staticRenderFns } from "./m-notFound-knives-info-dialog.vue?vue&type=template&id=db54e0d4&scoped=true&"
import script from "./m-notFound-knives-info-dialog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-notFound-knives-info-dialog.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-notFound-knives-info-dialog.vue?vue&type=style&index=0&id=db54e0d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db54e0d4",
  null
  
)

export default component.exports